import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/origemController');

export default class origemService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarOrigens() {
    return await this.axios.get(`/listarOrigens`);
  };

  async listarOrigensPorRole() {
    return await this.axios.get(`/listarOrigensPorRole`);
  };

  async listarOrigensAtivas() {
    return await this.axios.get(`/listarOrigensAtivas`);
  };
}